/**
 * Feature flags configuration for buck-chat
 * Following the pattern from landtrust repository
 */

const featureFlags = {
  MOCK_MESSAGES: 'feature_flag:MOCK_MESSAGES',
};

export default {
  featureFlags,
};
